const Ex_ProductionValidation = (values, rows) => {
  let errors = {};

  // Check if production items exist
  if (!values._productionItems || values._productionItems.length === 0) {
    errors._productionItems = "Please add at least one material";
    return errors;
  }

  // Check production quantity
  if (!values._productionQty || values._productionQty <= 0) {
    errors._productionQty = "Production quantity must be greater than 0";
    return errors;
  }

  // Validate each production item has required quantity
  let isErrorItem = false;
  values._productionItems.forEach((item) => {
    if (!item.usingQty || item.usingQty <= 0) {
      isErrorItem = true;
    }
  });

  if (isErrorItem) {
    errors._productionItems = "All materials must have quantity greater than 0";
    return errors;
  }

  // Check if there's sufficient stock for materials
  // Note: avlQty needs to be fetched/set in the rows if you want to validate stock
  if (rows && rows.length > 0) {
    let errorMsg = "Insufficient stock for: ";
    let isInsufficientQty = false;

    rows.forEach((row) => {
      // Calculate total qty needed
      const totalNeeded = row.itemQty * values._productionQty;

      // Only check if avlQty is available
      if (row.avlQty !== null && row.avlQty !== undefined) {
        if (row.avlQty < totalNeeded) {
          isInsufficientQty = true;
          errorMsg += `${row.item} (need: ${totalNeeded}, available: ${row.avlQty}), `;
        }
      }
    });

    if (isInsufficientQty) {
      errors._productionItems = errorMsg.slice(0, -2); // Remove trailing comma
    }
  }

  // Packaging cost and packaging person are optional, but must be provided together
  const packingCost = parseFloat(values._packingCost) || 0;
  if (packingCost > 0 && !values._packingPersonId) {
    errors._packingPerson = "Please select who is being paid the packaging cost";
  }
  if (values._packingPersonId && packingCost <= 0) {
    errors._packingCost = "Packaging cost must be greater than 0";
  }

  return errors;
};

export default Ex_ProductionValidation;
